import { Box, Divider, Icon, IconButton, Typography } from "@mui/material";
import { useContext } from "react";
import { DialogContext } from "../../contexts/DialogContext";

// updated
export default function DialogHeader(props: {
    title: string;
    action?: JSX.Element;
}) {
    const { closeDialog } = useContext(DialogContext);

    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    bgcolor: "background.paper",
                    py: 1,
                    px: 2,
                    minHeight: 45,
                }}
            >
                <Typography textAlign="center">{props.title}</Typography>

                {props.action ?? (
                    <IconButton onClick={closeDialog}>
                        <Icon>close</Icon>
                    </IconButton>
                )}
            </Box>

            <Divider />
        </>
    );
}
